<template>
  <el-upload
    class="avatar-uploader"
    :data="{upload_type:upload_type}"
    :name="upload_type"
    :action="VUE_APP_BASE_API+'/upload'"
    :show-file-list="false"
    accept="image/*"
    :on-success="success"
    :before-upload="beforeupload"
  >
    <img v-if="value" :src="value" class="avatar">
    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
  </el-upload>
</template>

<script>
export default {
  props: {
    // 类型
    upload_type: {
      type: String,
      required: true
    },
    // 双向绑定值
    value: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      VUE_APP_BASE_API: process.env.VUE_APP_BASE_API
    }
  },
  methods: {
    success (res) {
      
      if (res.code === 200) {
        this.$emit('input', 'https://' + res.data.url)
      } else {
        this.$message.error(res.msg)
      }
    },
    beforeupload (file) {
      

      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!')
      }
      return isLt2M
    }
  }
}
</script>

<style lang="scss" scoped>
.avatar-uploader ::v-deep{
  .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
}
</style>
